import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
export var createAudioDestinationNodeConstructor = function createAudioDestinationNodeConstructor(audioNodeConstructor, createAudioDestinationNodeRenderer, createIndexSizeError, createInvalidStateError, createNativeAudioDestinationNode, getNativeContext, isNativeOfflineAudioContext, renderInputsOfAudioNode) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(AudioDestinationNode, _audioNodeConstructor);
    function AudioDestinationNode(context, channelCount) {
      var _this;
      _classCallCheck(this, AudioDestinationNode);
      var nativeContext = getNativeContext(context);
      var isOffline = isNativeOfflineAudioContext(nativeContext);
      var nativeAudioDestinationNode = createNativeAudioDestinationNode(nativeContext, channelCount, isOffline);
      var audioDestinationNodeRenderer = isOffline ? createAudioDestinationNodeRenderer(renderInputsOfAudioNode) : null;
      _this = _possibleConstructorReturn(this, _getPrototypeOf(AudioDestinationNode).call(this, context, false, nativeAudioDestinationNode, audioDestinationNodeRenderer));
      _this._isNodeOfNativeOfflineAudioContext = isOffline;
      _this._nativeAudioDestinationNode = nativeAudioDestinationNode;
      return _this;
    }
    _createClass(AudioDestinationNode, [{
      key: "channelCount",
      get: function get() {
        return this._nativeAudioDestinationNode.channelCount;
      },
      set: function set(value) {
        // Bug #52: Chrome, Edge & Safari do not throw an exception at all.
        // Bug #54: Firefox does throw an IndexSizeError.
        if (this._isNodeOfNativeOfflineAudioContext) {
          throw createInvalidStateError();
        }
        // Bug #47: The AudioDestinationNode in Safari does not initialize the maxChannelCount property correctly.
        if (value > this._nativeAudioDestinationNode.maxChannelCount) {
          throw createIndexSizeError();
        }
        this._nativeAudioDestinationNode.channelCount = value;
      }
    }, {
      key: "channelCountMode",
      get: function get() {
        return this._nativeAudioDestinationNode.channelCountMode;
      },
      set: function set(value) {
        // Bug #53: No browser does throw an exception yet.
        if (this._isNodeOfNativeOfflineAudioContext) {
          throw createInvalidStateError();
        }
        this._nativeAudioDestinationNode.channelCountMode = value;
      }
    }, {
      key: "maxChannelCount",
      get: function get() {
        return this._nativeAudioDestinationNode.maxChannelCount;
      }
    }]);
    return AudioDestinationNode;
  }(audioNodeConstructor);
};